import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader } from "reactstrap";
import { useGetInventoryId } from "../../api/inventory/service/index";


const AddInventoryDetail = ({ vin }) => {
  const { data, isLoading, isError } = useGetInventoryId(vin,true);

  const [formData, setFormData] = useState({
    year: '',
    make: '',
    model: '',
    bodyStyle: '',
    driveType: '',
    transmission: '',
    engine: '',
    fuelType: '',
    type: '',
    exteriorColor: '',
    interiorColor: '',
    acquiredMileage: '',
    mileageStatus: '',
    exteriorPrimaryColor: '',
    exteriorSecondaryColor: '',
    vehicleLot: '',
    buyer: '',
    dateAcquired: '',
    acquiredPrice: '',
    acquiredRefNumber: '',
    acquiredFrom: '',
    acquiredFromName: '',
    paymentMethod: '',
    vin: vin,
  });

  useEffect(() => {
    if (data) {
      const vpic = data?.vpicData?.Results?.[0] || {};
      const inventory = data?.inventory || {};
      
      setFormData({
        year: vpic.ModelYear || inventory.model_year || '',
        make: vpic.Make || inventory.make || '',
        model: vpic.Model || inventory.model || '',
        bodyStyle: vpic.BodyClass || inventory.body_style || '',
        driveType: vpic.DriveType || inventory.drive_type || '',
        transmission: vpic.Transmission || inventory.transmission || '',
        engine: vpic.Engine || inventory.engine || '',
        fuelType: vpic.FuelType || inventory.fuel_type || '',
        type: vpic.Type || inventory.type || 'Unknown',
        exteriorColor: vpic.ExteriorColor || inventory.exterior_color || '',
        interiorColor: vpic.InteriorColor || inventory.interior_color || '',
        acquiredMileage: inventory.mileage || '',
        mileageStatus: inventory.mileage_status || '',
        exteriorPrimaryColor: vpic.ExteriorPrimaryColor || inventory.exterior_primary_color || '',
        exteriorSecondaryColor: vpic.ExteriorSecondaryColor || inventory.exterior_secondary_color || '',
        vehicleLot: inventory.vehicle_lot || 'Test Name',
        buyer: inventory.buyer || '',
        dateAcquired: inventory.date_acquired || '25/07/2025',
        acquiredPrice: inventory.acquired_price || '$0.00',
        acquiredRefNumber: inventory.acquired_ref_number || '',
        acquiredFrom: inventory.acquired_from || '',
        acquiredFromName: inventory.acquired_from_name || '',
        paymentMethod: inventory.payment_method || '',
        vin: vin,
      });
    }
  }, [data, vin]);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  if (isLoading) {
    return (
      <div className="content">
        <Card>
          <CardBody className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
            <p className="mt-3">Loading vehicle information...</p>
          </CardBody>
        </Card>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="content">
        <div className="alert alert-danger">
          <h4 className="alert-heading">Error!</h4>
          <p>Failed to load vehicle information for VIN: {vin}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="content">
      {/* VIN Header */}
      <div className="mb-4">
        <h2 className="font-weight-bold">
          {formData.vin} {formData.year} {formData.make} {formData.model}
        </h2>
      </div>

      <div className="row">
        {/* Vehicle Information Card */}
        <div className="col-md-6 mb-4">
          <Card>
            <CardHeader className="font-weight-bold text-uppercase">VEHICLE INFORMATION</CardHeader>
            <CardBody>
              <div className="form-group">
                <label>Year Model</label>
                <input 
                  type="number" 
                  className="form-control" 
                  value={formData.year}
                  onChange={(e) => handleInputChange('year', e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Make</label>
                <input 
                  type="text" 
                  className="form-control" 
                  value={formData.make}
                  onChange={(e) => handleInputChange('make', e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Model</label>
                <input 
                  type="text" 
                  className="form-control" 
                  value={formData.model}
                  onChange={(e) => handleInputChange('model', e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Body Style</label>
                <input 
                  type="text" 
                  className="form-control" 
                  value={formData.bodyStyle}
                  onChange={(e) => handleInputChange('bodyStyle', e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Drive Type</label>
                <input 
                  type="text" 
                  className="form-control" 
                  value={formData.driveType}
                  onChange={(e) => handleInputChange('driveType', e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Transmission</label>
                <input 
                  type="text" 
                  className="form-control" 
                  value={formData.transmission}
                  onChange={(e) => handleInputChange('transmission', e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Engine</label>
                <input 
                  type="text" 
                  className="form-control" 
                  value={formData.engine}
                  onChange={(e) => handleInputChange('engine', e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Fuel Type</label>
                <input 
                  type="text" 
                  className="form-control" 
                  value={formData.fuelType}
                  onChange={(e) => handleInputChange('fuelType', e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Type</label>
                <input 
                  type="text" 
                  className="form-control" 
                  value={formData.type}
                  onChange={(e) => handleInputChange('type', e.target.value)}
                />
              </div>
            </CardBody>
          </Card>
        </div>

        {/* Color and Mileage Information Card */}
        <div className="col-md-6 mb-4">
          <Card>
            <CardHeader className="font-weight-bold text-uppercase">COLOR & MILEAGE</CardHeader>
            <CardBody>
              <div className="form-group">
                <label>Exterior Color</label>
                <select 
                  className="form-control"
                  value={formData.exteriorColor}
                  onChange={(e) => handleInputChange('exteriorColor', e.target.value)}
                >
                  <option value="">Select Color</option>
                  <option value="Black">Black</option>
                  <option value="White">White</option>
                  <option value="Red">Red</option>
                  <option value="Blue">Blue</option>
                  <option value="Silver">Silver</option>
                </select>
              </div>
              <div className="form-group">
                <label>Interior Color</label>
                <select 
                  className="form-control"
                  value={formData.interiorColor}
                  onChange={(e) => handleInputChange('interiorColor', e.target.value)}
                >
                  <option value="">Select Trim</option>
                  <option value="Black">Black</option>
                  <option value="Gray">Gray</option>
                  <option value="Beige">Beige</option>
                  <option value="Brown">Brown</option>
                </select>
              </div>
              <div className="form-group">
                <label>Acquired Mileage</label>
                <input 
                  type="number" 
                  className="form-control" 
                  value={formData.acquiredMileage}
                  onChange={(e) => handleInputChange('acquiredMileage', e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Mileage Status</label>
                <select 
                  className="form-control"
                  value={formData.mileageStatus}
                  onChange={(e) => handleInputChange('mileageStatus', e.target.value)}
                >
                  <option value="">Select</option>
                  <option value="Actual">Actual</option>
                  <option value="Exempt">Exempt</option>
                  <option value="Not Actual">Not Actual</option>
                </select>
              </div>
              <div className="form-group">
                <label>Exterior Primary Color</label>
                <input 
                  type="text" 
                  className="form-control" 
                  value={formData.exteriorPrimaryColor}
                  onChange={(e) => handleInputChange('exteriorPrimaryColor', e.target.value)}
                />
              </div>
              <div className="form-group">
                <label>Exterior Secondary Color</label>
                <input 
                  type="text" 
                  className="form-control" 
                  value={formData.exteriorSecondaryColor}
                  onChange={(e) => handleInputChange('exteriorSecondaryColor', e.target.value)}
                />
              </div>
            </CardBody>
          </Card>
        </div>

        {/* Purchase Information Card */}
        <div className="col-md-12 mb-4">
          <Card>
            <CardHeader className="font-weight-bold text-uppercase">PURCHASE INFORMATION</CardHeader>
            <CardBody>
              <div className="row">
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Vehicle Lot *</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={formData.vehicleLot}
                      onChange={(e) => handleInputChange('vehicleLot', e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Buyer</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={formData.buyer}
                      onChange={(e) => handleInputChange('buyer', e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Date Acquired</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={formData.dateAcquired}
                      onChange={(e) => handleInputChange('dateAcquired', e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Acquired Price</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={formData.acquiredPrice}
                      onChange={(e) => handleInputChange('acquiredPrice', e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Acquired Ref Number</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={formData.acquiredRefNumber}
                      onChange={(e) => handleInputChange('acquiredRefNumber', e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Acquired From</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={formData.acquiredFrom}
                      onChange={(e) => handleInputChange('acquiredFrom', e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Acquired From Name</label>
                    <input 
                      type="text" 
                      className="form-control" 
                      value={formData.acquiredFromName}
                      onChange={(e) => handleInputChange('acquiredFromName', e.target.value)}
                    />
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label>Payment Method</label>
                    <select 
                      className="form-control"
                      value={formData.paymentMethod}
                      onChange={(e) => handleInputChange('paymentMethod', e.target.value)}
                    >
                      <option value="">Select Method</option>
                      <option value="Cash">Cash</option>
                      <option value="Check">Check</option>
                      <option value="Wire Transfer">Wire Transfer</option>
                      <option value="Credit Card">Credit Card</option>
                    </select>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>

        {/* VIN History Card */}
        <div className="col-md-12 mb-4">
          <Card>
            <CardHeader className="font-weight-bold text-uppercase">VIN HISTORY</CardHeader>
            <CardBody>
              <div className="alert alert-info">
                No VIN history found.
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default AddInventoryDetail; 